import { Box, Typography } from "@material-ui/core";
import React from "react"; 
import { dateToDateAge } from "../../components/general/formateDate";
import { removeLeadingComma } from "./utils";


 const UserDetails = ({user}) => {
    return (
        <Box style={{ width: '250px', paddingLeft:8, marginTop: '-5px' }}>
            <Typography variant="body2">Age: {dateToDateAge(user.Birth)}</Typography>
            <Typography variant="body2">Langue(s)   : {removeLeadingComma(user.Langue)}</Typography>
        </Box>
    )
}

export default UserDetails